import { GraphQLError } from 'graphql';
import type { GraphQLFormattedError } from 'graphql';

// https://www.apollographql.com/docs/apollo-server/data/errors#built-in-error-codes
const ApolloErrorCodes = {
  BAD_USER_INPUT: 'BAD_USER_INPUT',
  GRAPHQL_VALIDATION_FAILED: 'GRAPHQL_VALIDATION_FAILED',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
};

const ErrorCodes = {
  ...ApolloErrorCodes,
  FORBIDDEN: 'FORBIDDEN',
  INVALID_FORMAT: 'INVALID_FORMAT',
  UNAUTHORIZED: 'UNAUTHORIZED',
  // Error we forgot to or missed adding a deliberate `code` for. Should not exist permanently.
  UNKNOWN: 'UNKNOWN',
  UNPROCESSABLE_ENTITY: 'UNPROCESSABLE_ENTITY',
  VALIDATION: 'VALIDATION',
};

// Original error from backend
type GraphQLExtendedError = {
  message: string;
  extensions: {
    code: string;
    field?: string;
    kind?: string;
    validation?: string;
  };
};

type GraphQLCodedError = {
  message: string;
  code: string;
};

type GraphQLValidationError = {
  message: string;
  code: 'VALIDATION';
  field: string;
  validation?: string;
  kind?: string;
};

const normalizeGraphQLError = (
  err: GraphQLError | GraphQLFormattedError | undefined,
): GraphQLCodedError | GraphQLValidationError => {
  if (!err) {
    return { message: 'Unknown error', code: ErrorCodes.UNKNOWN };
  }
  if (err instanceof GraphQLError) {
    return normalizeGraphQLError(err.toJSON());
  }
  const error = err as GraphQLExtendedError;
  const extensions = error.extensions || {};
  return { message: error.message, ...extensions };
};

export { ErrorCodes };
export default normalizeGraphQLError;
